import React from "react";

function Header({ zmienSekcje }) {
    return (
        <header className="header">
            <a href="#" className="logo">💻 Mikuś Web</a>
            <nav className="navbar">
                <a href="#" onClick={() => zmienSekcje("home")}>Oferta</a>
                <a href="#" onClick={() => zmienSekcje("portfolio")}>Portfolio</a>
                <a href="#" onClick={() => zmienSekcje("projects")}>Nasze projekty</a>
                <a href="#" onClick={() => zmienSekcje("kontakt")}>Kontakt</a>
            </nav>
        </header>
    );
}

export default Header;
